export default {
  fields: [
    {
      name: 'supervisorLicences',
      label: 'Insight Supervisor Licences',
      validate: 'required|number',
      hint: 'Customer is responsible for assigning purchased licences to specific users, 1st login is created as default user by Vonex staff',
      product: 'insight',
      cost: 10,
      quantity: 1,
    },
    {
      name: 'callRecordings',
      label: 'Call Recordings Licences',
      validate: 'required|number',
      hint: 'Customer is responsible for assigning purchased licences to specific extensions or agent groups',
      product: 'insight',
      cost: 8,
      quantity: null,
    },

    {
      name: 'reportSupervisorLicences',
      label: 'Report Supervisor Licences',
      validate: 'required|number',
      hint: 'Customer is responsible for assigning purchased licences to specific users, 1st login is created as default user by Vonex staff',
      product: 'report',
      cost: 20,
      quantity: 1,
    },
    {
      name: 'supervisorLicences',
      label: 'Insight Supervisor Licences',
      validate: 'required|number',
      hint: 'Customer is responsible for assigning purchased licences to specific users, 1st login is created as default user by Vonex staff',
      product: 'report',
      cost: 10,
      quantity: null,
    },
    {
      name: 'myConsole',
      label: 'My Console Licences',
      validate: 'required|number',
      hint: 'Customer is responsible for assigning purchased licences to specific users, My Console login only allows acces to each user’s individual extension',
      product: 'report',
      cost: 4,
      quantity: null,
    },
    {
      name: 'callRecordings',
      label: 'Call Recordings Licences',
      validate: 'required|number',
      hint: 'Customer is responsible for assigning purchased licences to specific extensions or agent groups',
      product: 'report',
      cost: 8,
      quantity: null,
    },
  ],
};
